export default "__VITE_ASSET__BccKIyP5__"